import compareAppVersion from './compareAppVersion.js';
export default class CallPopup {
    static async setUp(opportunity, pageId, extraParam = {}) {
        // const opportunity = 1;
        window.PPDWebUI && window.PPDWebUI.PopupService && window.PPDWebUI.PopupService.registerPopup({ opportunity, pageId, extraParam });
    }
    static showPopup(pageId, extraParam = {}) {
        console.log(pageId, extraParam, 'showPopup-show-11');
        return new Promise((resolve, reject) => {
            window.PPDWebUI && window.PPDWebUI.PopupService && window.PPDWebUI.PopupService.show(
                { pageId, extraParam },
                (res) => {
                    resolve(true);
                    console.log(res, 'showPopup-succ');
                },
                (err) => {
                    resolve(false);
                    console.log(err, 9999);
                });
        });
    }
    static compareAppVer(targetVer) {
        return new Promise(resolve => {
            let value = compareAppVersion(window.PPDWebUI.os.buildVersion, targetVer, '<');
            resolve(value);
        });
    }

}
